
import { Component, Input, Output, EventEmitter, ViewEncapsulation, OnChanges, ElementRef, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { closingContentChanges, ClosingContentChangeType } from '../../../../../interfaces/responsedata.ts/generic-streams';


@Component({
    selector: 'app-html-template-view',
    standalone: false,
    templateUrl: './html-template-view.component.html',
    styleUrl: './html-template-view.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class HtmlTemplateViewComponent implements OnChanges, AfterViewInit {
    @Input({ required: true }) content: SafeHtml | string = "";
    @Input({ required: true }) name: string = "ideastream asset";
    @Output() contentChanged = new EventEmitter<{ changes: any[], updatedContent: string }>();
    @ViewChild('htmlContent', { read: ElementRef, static: false }) htmlContentRef!: ElementRef;
    private previousValues: Map<HTMLElement, string> = new Map();

    changes: closingContentChanges[] = [];

    ngAfterViewInit() {
        this.initializeContent();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['content'] && !changes['content'].isFirstChange() && this.htmlContentRef) {
            setTimeout(() => this.initializeContent(), 0);
        }
    }

    public async exportAsPdf(): Promise<boolean> {
        // // HTML => Canvas => PDF
        // if (!this.htmlContentRef) return false;

        // const element = this.htmlContentRef.nativeElement as HTMLElement;

        // // Find dic with id container
        // const container = element.querySelector('#container') as HTMLElement;
        // if (!container) {
        //     console.error("Container Element nicht gefunden");
        //     return false;
        // }

        // const visibleElements = Array.from(container.children).filter((child) => {
        //     const style = window.getComputedStyle(child);
        //     return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        // }) as HTMLElement[];

        // if (visibleElements.length === 0) {
        //     console.error("Keine sichtbaren Elemente zum Exportieren gefunden");
        //     return false;
        // }

        // try {
        //     domToPng(visibleElements[0]).then((dataUrl) => {
        //         const link = document.createElement('a')
        //         link.download = 'screenshot.png'
        //         link.href = dataUrl
        //         link.click()

        //     });
        //     return true;

        // } catch (error) {
        //     console.error("Fehler beim Exportieren als PDF:", error);
        //     return false;
        // }
        return false;
    }

    private initializeContent() {
        if (!this.htmlContentRef) return;

        // Editierbare Spans finden und Events registrieren
        const editableSpans = this.htmlContentRef.nativeElement.querySelectorAll('span[contenteditable="true"]');

        editableSpans.forEach((span: HTMLElement) => {
            // Initialen Text speichern
            this.previousValues.set(span, span.innerText);

            // Events registrieren
            span.addEventListener('input', () => this.handleSpanChange(span));
            span.addEventListener('blur', () => this.handleSpanChange(span));

            // Visuelles Feedback
            // span.style.transition = 'background-color 0.3s';
            // span.addEventListener('focus', () => {
            //     span.style.backgroundColor = '#f0f0f0';
            // });
            // span.addEventListener('blur', () => {
            //     span.style.backgroundColor = 'transparent';
            // });
        });
    }
    public async generateHtmlElementToPrint(): Promise<false | HTMLElement> {
        if (!this.htmlContentRef) return false;

        const element = (this.htmlContentRef.nativeElement as HTMLElement)

        // Find div with id container
        const container = element.querySelector('#container') as HTMLElement;
        if (!container) {
            console.error("Container Element nicht gefunden");
            return false;
        }
        console.log("=== Container element found.");



        const visibleElements = Array.from(container.children).filter((child) => {
            const style = window.getComputedStyle(child);
            return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        }) as HTMLElement[];

        if (visibleElements.length === 0) {
            console.error("Keine sichtbaren Elemente zum Exportieren gefunden");
            return false;
        }
        console.log("=== Visible elmeents:", visibleElements.length);

        const styles = visibleElements[0].querySelectorAll("*");
        styles.forEach((el) => {
            if (el.tagName.toLowerCase() === 'img') {
                (el as HTMLImageElement).removeAttribute('loading');
            }
            const computedStyle = window.getComputedStyle(el);
            (el as HTMLElement).style.cssText = computedStyle.cssText;
        });
        return visibleElements[0];
    }

    private handleSpanChange(span: HTMLElement) {
        if (!span.id) span.id = new Date().getTime().toString();

        const previousValue = this.previousValues.get(span);
        const currentValue = span.innerText.trim();

        if (previousValue === currentValue) {
            return; // Keine Änderung
        }
        let dataKey = span.getAttribute('data-key') || '';
        // Get all span mit dem gleichen data-key
        const allSpans = this.htmlContentRef.nativeElement.querySelectorAll(`span[data-key="${dataKey}"]`);

        allSpans.forEach((s: HTMLElement) => {
            if (s.id === span.id) return; // Skip the original span
            s.innerText = currentValue;
        });


        let exists = this.changes.find(c => c.elementId === span.id);
        if (exists) {
            exists.to = currentValue;
            // console.log('Span Text geändert:', exists);

            // Neuen Wert speichern
            this.previousValues.set(span, currentValue);

            // Gesamten aktualisierten Content emittieren
            if (this.htmlContentRef) {
                const updatedContent = this.htmlContentRef.nativeElement.innerHTML;
                this.contentChanged.emit({ "changes": this.changes, "updatedContent": updatedContent });
            }
        } else {

            let change: closingContentChanges = {
                time: new Date().getTime(),
                type: ClosingContentChangeType.TEXT,
                elementId: span.id,
                from: previousValue?.toString() || '',
                to: currentValue
            };
            this.changes.push(change);
            // console.log('Span Text geändert:', change);

            // Neuen Wert speichern
            this.previousValues.set(span, currentValue);

            // Gesamten aktualisierten Content emittieren
            if (this.htmlContentRef) {
                const updatedContent = this.htmlContentRef.nativeElement.innerHTML;
                this.contentChanged.emit({ "changes": this.changes, "updatedContent": updatedContent });
            }
        }
    }
}
